import React from 'react';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ClearIcon from '@mui/icons-material/Clear';

import LabeledCustomSelect from 'components/elements/LabeledCustomSelect';

const Filters = ({
                   filters,
                   handleChangeRunStatus = () => {
                   },
                   handleChangeDatasetType = () => {
                   },
                   handleChangePipelineRunId = () => {
                   },
                   handleChangeExperimentId = () => {
                   },
                 }) => {
  const {t} = useTranslation();
  const runStatuses = [
    {id: 'Running', name: 'Running', value: 'RUNNING'},
    {id: 'Success', name: 'Success', value: 'SUCCESS'},
    {id: 'Error', name: 'Error', value: 'ERROR'}
  ];
  const pipelineTypes = [
    {
      id: 'TRENDS',
      name: t('feature.configure.pipelines.trend_analysis'),
      value:'Trends Analysis'
    },
    {
      id: 'IMPACT_ANALYSIS',
      name: t('feature.configure.pipelines.impact_lever_analysis'),
      value: 'Impact Analysis'
    },
    {
      id: 'PPSM',
      name: t('feature.configure.pipelines.ppsm'),
      value: 'PPSM'
    },
    {
      id: 'REPORT_GENERATION',
      name: t('feature.configure.pipelines.report'),
      value: 'Report Generation'
    }
  ];

  return (
    <Grid container justifyContent="flex-start" spacing={0.5} alignItems="flex-end">
      {/* View All Pipelines Button Column */}
      <Grid item xs={4} container spacing={0.5}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: '0.75rem',
              color: '#989898',
              height: '18px', // Fixed height for consistent spacing
            }}>
            {/* Empty space for alignment */}
          </Typography>
        </Grid>

        {(filters.pipeline_run_id || filters.experiment_id) && (
          <Grid item xs={12}>
            <Button
              variant="outlined"
              size="small"
              onClick={() => {
                if (filters.pipeline_run_id) {
                  handleChangePipelineRunId('');
                } else {
                  handleChangeExperimentId('');
                }
              }}
              sx={{
                fontSize: '0.875rem',
                padding: '6px 12px',
                color: '#1976d2',
                borderColor: '#c4c4c4',
                textTransform: 'none',
                backgroundColor: '#fff',
                height: '40px',
              }}
            >
              View All Pipelines
            </Button>
          </Grid>
        )}
      </Grid>

      {/* Pipeline Type Filter */}
      <Grid item xs={4} container spacing={0.5}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: '0.75rem',
              color: '#989898',
              height: '18px',
            }}>
            {'Pipeline Type'}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <LabeledCustomSelect
            id="select-dataset-types"
            name="dataset-types"
            // placeholder={t('Pipeline Type')}
            selectItems={pipelineTypes}
            showClear
            onClear={()=>handleChangeDatasetType('')}
            value={filters.type}
            sx={{backgroundColor: '#fff'}}
            onChange={(e) => {
              handleChangeDatasetType(e.target.value);
            }}
          />
        </Grid>
      </Grid>

      {/* Run Status Filter */}
      <Grid item xs={4} container spacing={0.5}>
        <Grid item xs={12}>
          <Typography
            sx={{
              fontSize: '0.75rem',
              color: '#989898',
              height: '18px',
            }}>
            {t('feature.datasets.management.filters.run.status.placeholder')}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <LabeledCustomSelect
            id="select-run-statuses"
            name="runStatuses"
            // placeholder={t('feature.datasets.management.filters.run.status.placeholder')}
            selectItems={runStatuses}
            showClear
            onClear={()=>handleChangeRunStatus('')}
            value={filters.status}
            sx={{backgroundColor: '#fff'}}
            onChange={(e) => {
              handleChangeRunStatus(e.target.value);
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Filters;